<template>
  <card-total
    text="CONTRATOS NAVIXY"
    icon="mdi mdi-file-document-edit  danger-text"
    :total="total"
    :loading.sync="loading"
  >
    <template #total="slotProsps">
      <a href="#" @click.prevent="openDetail">{{ slotProsps.total }}</a>
    </template>
    <template #moreIcons>
      <span style="font-size: 95%" class="info-text self-flex-start">
        <i class="el-icon-view" /> Equipos : {{ qtyEquipment }}</span
      >
      <NavixyUserNotContractList :drawer.sync="drawer" />
    </template>
  </card-total>
</template>

<script>
import CardTotal from "@/components/CardTotalOriginal.vue";
import NavixyUserNotContractList from "@/components/NavixyUserNotContractList.vue";

export default {
  name: "CardNavixySinContract",
  components: { CardTotal, NavixyUserNotContractList },

  async created() {
    await this.$store.dispatch("navixy/getTotalUsers");
    await this.$store.dispatch("navixy/getTotalGps");
    this.getTotalUsersNotContract();
  },
  data() {
    return {
      total: 0,
      loading: false,
      drawer: false,
      qtyEquipment: 0,
      users: []
    };
  },
  methods: {
    openDetail() {
      this.drawer = true;
    },
    getTotalUsersNotContract() {
      this.loading = true;
      //var equipos = this.$store.getters["navixy/getTrackers"];
      // this.$http
      //   .get("/api/navixy/GetTotalUsersNotContract", {
      //     timeout: 3 * 60 * 1000
      //   })
      //   .then((resp) => {
      //     this.total = resp.data.total;
      //     this.qtyEquipment = resp.data.qtyEquipment;
      //     this.loading = false;
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //     this.loading = false;
      //   });
      this.users = this.$store.getters["navixy/getUserList"];
      this.total = this.users.length;
      this.loading = false;
    }
  }
};
</script>

<style></style>
